import React from 'react';
import { Button } from 'reactstrap';
import { PropertiesList } from '../../models/propertyModel';

type Props = {
  property: PropertiesList;
  setFeaturesProperty: (p: PropertiesList) => void;
  setFeaturesModalOpen: (open: boolean) => void;
  EDIT_BUTTON_STYLE: React.CSSProperties;
};

const PropertyFeaturesDetail: React.FC<Props> = ({
  property,
  setFeaturesProperty,
  setFeaturesModalOpen,
  EDIT_BUTTON_STYLE,
}) => (
  <div
    className="detalle-agrupado-cell"
    style={{
      position: 'relative',
      minHeight: 40,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <div
      className="detalle-edit-btn"
      style={{
        position: 'absolute',
        top: 10,
        right: 18,
        zIndex: 2,
        opacity: 0,
        transition: 'opacity 0.2s',
        pointerEvents: 'none',
      }}
    >
      <Button
        size="sm"
        color="primary"
        outline
        style={EDIT_BUTTON_STYLE}
        title="Editar características"
        onClick={() => {
          setFeaturesProperty(property);
          setFeaturesModalOpen(true);
        }}
      >
        <i className="fas fa-edit" />
      </Button>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <span>
        <b>Destacado:</b> {property.is_featured ? 'Sí' : 'No'}
      </span>
      <span>
        <b>Tipo:</b> {property.propertyType?.name ?? 'N/A'}
      </span>
      <span>
        <b>Está amueblado:</b> {property.is_furnished ? 'Sí' : 'No'}
      </span>
      <span>
        <b>Acepta mascotas:</b> {property.pets_allowed ? 'Sí' : 'No'}
      </span>
      <span>
        <b>Contiene línea blanca:</b> {property.has_white_goods ? 'Sí' : 'No'}
      </span>
      <span>
        <b>Acepta Airbnb:</b> {property.accept_airbnb ? 'Sí' : 'No'}
      </span>

       <span>
        <b>Con Avaluo:</b> {property.with_assessment ? 'Sí' : 'No'}
      </span>
    </div>
  </div>
);

export default PropertyFeaturesDetail;